import { Banner } from "components/Banner";

export const BannerSection = () => (
  <div className="px-6 md:px-12 lg:px-20 bg-lue-blue-300">
    <Banner isFloating />
  </div>
);
